import { useEffect, useState } from "react";
import { Button, Modal, DatePicker } from "shared";
import { ButtonSizes, ButtonVariants } from "shared/Button/Button";

type TDateRangeModalProps = {
  fromDate: Date | null;
  toDate: Date | null;
  onApply: (fromDate: Date | null, toDate: Date | null) => void;
  onClose: () => void;
  isOpen: boolean;
  labels?: {
    close?: string;
    heading?: string;
    title?: string;
    fromLabel?: string;
    fromPlaceholder?: string;
    toLabel?: string;
    toPlaceholder?: string;
    showResults?: string;
    clearFilters?: string;
  }
};

function DateRangeModal({
  fromDate,
  toDate,
  onApply,
  onClose,
  isOpen,
  labels
}: TDateRangeModalProps) {
  const [selectedFromDate, setSelectedFromDate] = useState<Date>();
  const [selectedToDate, setSelectedToDate] = useState<Date>();

  useEffect(() => {
    setSelectedFromDate(fromDate ?? undefined);
    setSelectedToDate(toDate ?? undefined);
  }, [fromDate, toDate]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={labels?.heading || "Filter by date"} closeLabel={labels?.close}>
      <div className="m-date-range-modal">
        <span className="m-date-range-modal__heading">{labels?.title || 'Select date range'}</span>
        <DatePicker
          variant="outsideLabel"
          onChange={(date) => setSelectedFromDate(date ?? undefined)}
          value={selectedFromDate ?? null}
          label={labels?.fromLabel || "From"}
          placeholder={labels?.fromPlaceholder || "Select Date"}
        />
        <DatePicker
          variant="outsideLabel"
          onChange={(date) => setSelectedToDate(date ?? undefined)}
          value={selectedToDate ?? null}
          label={labels?.toLabel || "To"}
          placeholder={labels?.toPlaceholder || "Select Date"}
        />
        <Button
            text={labels?.showResults || "Show Results"}
            onClick={() =>
              onApply(selectedFromDate ?? null, selectedToDate ?? null)
            }
            type="button"
            variant={ButtonVariants.Outlined}
            size={ButtonSizes.Small}
          />
          <Button
            text={labels?.clearFilters || "Clear Filters"}
            onClick={() => {
              setSelectedFromDate(undefined);
              setSelectedToDate(undefined);
            }}
            type="button"
            variant={ButtonVariants.Default}
            size={ButtonSizes.Small}
          />
      </div>
    </Modal>
  );
}

export default DateRangeModal;
